/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_OrganizationInputs */

const en_nav_organization = /** @type {(inputs: Nav_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Nav_OrganizationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_organization = /** @type {((inputs?: Nav_OrganizationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_OrganizationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_organization(inputs)
});